(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (function() {
    var hash = window.location.hash.slice(1);
    if (!hash) return;

    var details = document.getElementById(hash);
    if (details && details.tagName === 'DETAILS') {
      details.open = true;
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion-read-more"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-accordion-read-more]');
    if (!button) return;

    var anchorHash = button.getAttribute('data-anchor-hash');

    if (anchorHash) {
      // New behavior: navigate to a specific hash
      var isExternalPage = anchorHash.includes('/');
      if (isExternalPage) {
        // External page - let browser handle navigation
        window.location.href = anchorHash;
      } else {
        // Current page anchor
        var details = document.querySelector(anchorHash);
        if (!details) return;

        // Open the accordion
        details.open = true;

        // Scroll to it - scrollIntoView respects CSS scroll-margin-top
        details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Legacy behavior: find accordion in ProductInformation section
      var container = button.closest('[id^="ProductInformation-"]');
      if (!container) return;

      var accordionCustom = container.querySelector('.accordion accordion-custom');
      if (!accordionCustom) return;

      var details = accordionCustom.querySelector('details');
      if (!details) return;

      details.open = true;

      // scrollIntoView respects CSS scroll-margin-top
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function setNormalizeIframeRatios() {
      document.querySelectorAll('.accordion--normalize .details-content iframe').forEach(function (iframe) {
        var w = parseInt(iframe.getAttribute('width'), 10);
        var h = parseInt(iframe.getAttribute('height'), 10);
        if (w && h) iframe.style.aspectRatio = w + ' / ' + h;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setNormalizeIframeRatios);
    } else {
      setNormalizeIframeRatios();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
